(function(){
'use strict';
function resolveVideo(value){
 var u;try{u=new URL(String(value).trim().replace(/^http:/i,'https:'));}catch(e){return null;}
 if(u.protocol!=='https:')return null;
 var host=u.hostname.toLowerCase(), id;
 if(['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtu.be','youtube-nocookie.com','www.youtube-nocookie.com'].includes(host)){
  id=(host==='youtu.be'||host==='www.youtu.be')?u.pathname.split('/')[1]:u.searchParams.get('v')||u.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1];
  if(id && /^[A-Za-z0-9_-]{11}$/.test(id))return {type:'iframe',src:'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0',poster:'https://i.ytimg.com/vi/'+id+'/hqdefault.jpg'};
 }
 if(['vimeo.com','www.vimeo.com','player.vimeo.com'].includes(host)){
  id=u.pathname.match(/\/(?:video\/)?(\d+)/)?.[1];
  if(id){var v=new URL('https://player.vimeo.com/video/'+id);var h=u.searchParams.get('h')||u.pathname.match(/\/\d+\/([a-zA-Z0-9]+)/)?.[1];if(h)v.searchParams.set('h',h);return {type:'iframe',src:v.href};}
 }
 if(host==='drive.google.com'){
  id=u.pathname.match(/\/file\/d\/([A-Za-z0-9_-]+)/)?.[1]||u.searchParams.get('id');
  if(id && /^[A-Za-z0-9_-]+$/.test(id)){var d=new URL('https://drive.google.com/file/d/'+id+'/preview');if(u.searchParams.has('resourcekey'))d.searchParams.set('resourcekey',u.searchParams.get('resourcekey'));return {type:'iframe',src:d.href};}
 }
 if(/\.(mp4|webm|ogv)$/i.test(u.pathname))return {type:'video',src:u.href};
 return null;
}
function init(scope){scope.querySelectorAll('[data-km-video-url]').forEach(function(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 var spec=resolveVideo(root.dataset.kmVideoUrl),button=root.querySelector('button');
 if(!button)return;
 if(!spec){button.hidden=true;var message=root.querySelector('[data-video-message]');if(message){message.hidden=false;message.textContent='Use the video link below to watch this video.';}return;}
 button.querySelectorAll('img').forEach(function(img){img.addEventListener('error',function(){img.remove();},{once:true});});
 if(spec.poster&&!button.querySelector('img')){var poster=new Image();poster.alt='';poster.loading='lazy';poster.width=1280;poster.height=720;poster.addEventListener('error',function(){poster.remove();},{once:true});poster.src=spec.poster;button.prepend(poster);}
 button.addEventListener('click',function(){
 var media=document.createElement(spec.type==='video'?'video':'iframe');media.src=spec.src;
 if(spec.type==='video'){media.controls=true;media.playsInline=true;media.preload='metadata';}
 else{media.title=root.dataset.videoTitle||'Kidsmate product video';media.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';media.allowFullscreen=true;media.referrerPolicy='strict-origin-when-cross-origin';}
 root.insertBefore(media,button);button.remove();media.focus();
 },{once:true});
});}
window.KMResolveVideo=resolveVideo;
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
